var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9647 14.2549H15.7547L20.7447 19.2549L19.2547 20.7449L14.2547 15.7549V14.9649L13.9847 14.6849C12.8447 15.6649 11.3647 16.2549 9.75474 16.2549C6.16474 16.2549 3.25474 13.3449 3.25474 9.75488C3.25474 6.16488 6.16474 3.25488 9.75474 3.25488C13.3447 3.25488 16.2547 6.16488 16.2547 9.75488C16.2547 11.3649 15.6647 12.8449 14.6847 13.9849L14.9647 14.2549ZM5.25519 9.755C5.25519 12.245 7.26519 14.255 9.75519 14.255C12.2452 14.255 14.2552 12.245 14.2552 9.755C14.2552 7.265 12.2452 5.255 9.75519 5.255C7.26519 5.255 5.25519 7.265 5.25519 9.755Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMobileIcon);
export default __webpack_public_path__ + "static/media/search-mobile-icon.3ade94fae019abb6b3876ba5f5ba4f22.svg";
export { ForwardRef as ReactComponent };